import { styled } from "@mui/material/styles";
import Popover, { popoverClasses } from "@mui/material/Popover";

export const Container = styled(Popover, {
  label: "travelers-list",
})`
  .${popoverClasses.paper} {
    ${({ theme }) => theme.breakpoints.down("md")} {
      background-color: ${({ theme }) => theme.palette.color.gray[95]};
    }

    margin-top: ${({ theme }) => theme.spacing(0.5)};
    margin-left: ${({ theme }) => theme.spacing(3.5)};
    border-radius: ${({ theme }) => theme.spacing(1.5)};
    box-shadow: none;
    filter: drop-shadow(${({ theme }) => theme.customShadows.soft});
    padding-right: ${({ theme }) => theme.spacing(4)};
  }
`;

export const TravelersList = styled("ul", {
  label: "travelers-list",
})`
  color: ${({ theme }) => theme.palette.color.text.primary};
  list-style: none;
  padding: 0;

  ${({ theme }) => theme.breakpoints.down("md")} {
    color: ${({ theme }) => theme.palette.primary.main};
  }
`;

export const TravelerItem = styled("li", {
  label: "traveler-item",
})`
  && {
    font-weight: 500;
    font-size: 16px;
    display: block;
    margin: ${({ theme }) => theme.spacing(2, 2)};
  }
`;
